import { PaymentManager } from "./PaymentManager";

export default PaymentManagerimport { PaymentManager } from "./PaymentManager";

export default PaymentManager